import { 
  DEVICE_UNLOCK_HOME_API,
  DEVICE_UNLOCK_CHECK_API,
  DEVICE_UNLOCK_LOCKED_STRAIGHTTALK_API,
  DEVICE_UNLOCK_LOCKED_TRACFONE_API,
  DEVICE_UNLOCK_LOCKED_TOTAL_WIRELESS_API,
  DEVICE_UNLOCK_LOCKED_SIMPLEMOBILE_API,
  DEVICE_UNLOCK_UNLOCKED_STRAIGHTTALK_API,
  DEVICE_UNLOCK_UNLOCKED_TRACFONE_API,
  DEVICE_UNLOCK_UNLOCKED_TOTAL_WIRELESS_API,
  DEVICE_UNLOCK_UNLOCKED_SIMPLEMOBILE_API,
  DEVICE_UNLOCK_ELIGIBLE_STRAIGHTTALK_API,
  DEVICE_UNLOCK_ELIGIBLE_TRACFONE_API,
  DEVICE_UNLOCK_ELIGIBLE_TOTAL_WIRELESS_API,
  DEVICE_UNLOCK_ELIGIBLE_SIMPLEMOBILE_API,
  DEVICE_UNLOCK_INELIGIBLE_STRAIGHTTALK_API,
  DEVICE_UNLOCK_INELIGIBLE_TRACFONE_API,
  DEVICE_UNLOCK_INELIGIBLE_TOTAL_WIRELESS_API,
  DEVICE_UNLOCK_INELIGIBLE_SIMPLEMOBILE_API,
  DEVICE_UNLOCK_SUBMIT_STRAIGHTTALK_API,
  DEVICE_UNLOCK_SUBMIT_TRACFONE_API,
  DEVICE_UNLOCK_SUBMIT_TOTAL_WIRELESS_API,
  DEVICE_UNLOCK_SUBMIT_SIMPLEMOBILE_API,
  DEVICE_UNLOCK_ORDER_SUMMARY_STRAIGHTTALK_API,
  DEVICE_UNLOCK_ORDER_SUMMARY_TRACFONE_API,
  DEVICE_UNLOCK_ORDER_SUMMARY_TOTAL_WIRELESS_API,
  DEVICE_UNLOCK_ORDER_SUMMARY_SIMPLEMOBILE_API,
  SOE_HEALTH_CHECK_API,
  SOE_ELIGIBILITY_CHECK_API
} from "./apiContracts";
import { ServerApiContractsProps } from "./types";

export const serverApiContracts: ServerApiContractsProps = {
  "deviceUnlockHome": () => ({
    "straighttalk": DEVICE_UNLOCK_HOME_API,
    "tracfone": DEVICE_UNLOCK_HOME_API,
    "totalwireless": DEVICE_UNLOCK_HOME_API,
    "simplemobile": DEVICE_UNLOCK_HOME_API,
  }),
  "deviceUnlockCheck": () => ({
    "straighttalk": DEVICE_UNLOCK_CHECK_API,
    "tracfone": DEVICE_UNLOCK_CHECK_API,
    "totalwireless": DEVICE_UNLOCK_CHECK_API,
    "simplemobile": DEVICE_UNLOCK_CHECK_API,
  }),
  "deviceUnlockLocked": () => ({
    "straighttalk": DEVICE_UNLOCK_LOCKED_STRAIGHTTALK_API,
    "tracfone": DEVICE_UNLOCK_LOCKED_TRACFONE_API,
    "totalwireless": DEVICE_UNLOCK_LOCKED_TOTAL_WIRELESS_API,
    "simplemobile": DEVICE_UNLOCK_LOCKED_SIMPLEMOBILE_API,
  }),
  "deviceUnlockUnlocked": () => ({
    "straighttalk": DEVICE_UNLOCK_UNLOCKED_STRAIGHTTALK_API,
    "tracfone": DEVICE_UNLOCK_UNLOCKED_TRACFONE_API,
    "totalwireless": DEVICE_UNLOCK_UNLOCKED_TOTAL_WIRELESS_API,
    "simplemobile": DEVICE_UNLOCK_UNLOCKED_SIMPLEMOBILE_API,
  }),
  "deviceUnlockEligible": () => ({
    "straighttalk": DEVICE_UNLOCK_ELIGIBLE_STRAIGHTTALK_API,
    "tracfone": DEVICE_UNLOCK_ELIGIBLE_TRACFONE_API,
    "totalwireless": DEVICE_UNLOCK_ELIGIBLE_TOTAL_WIRELESS_API,
    "simplemobile": DEVICE_UNLOCK_ELIGIBLE_SIMPLEMOBILE_API,
  }),
  "deviceUnlockIneligible": () => ({
    "straighttalk": DEVICE_UNLOCK_INELIGIBLE_STRAIGHTTALK_API,
    "tracfone": DEVICE_UNLOCK_INELIGIBLE_TRACFONE_API,
    "totalwireless": DEVICE_UNLOCK_INELIGIBLE_TOTAL_WIRELESS_API,
    "simplemobile": DEVICE_UNLOCK_INELIGIBLE_SIMPLEMOBILE_API,
  }),
  "deviceUnlockSubmit": () => ({
    "straighttalk": DEVICE_UNLOCK_SUBMIT_STRAIGHTTALK_API,
    "tracfone": DEVICE_UNLOCK_SUBMIT_TRACFONE_API,
    "totalwireless": DEVICE_UNLOCK_SUBMIT_TOTAL_WIRELESS_API,
    "simplemobile": DEVICE_UNLOCK_SUBMIT_SIMPLEMOBILE_API,
  }),
  "deviceUnlockOrderSummary": () => ({
    "straighttalk": DEVICE_UNLOCK_ORDER_SUMMARY_STRAIGHTTALK_API,
    "tracfone": DEVICE_UNLOCK_ORDER_SUMMARY_TRACFONE_API,
    "totalwireless": DEVICE_UNLOCK_ORDER_SUMMARY_TOTAL_WIRELESS_API,
    "simplemobile": DEVICE_UNLOCK_ORDER_SUMMARY_SIMPLEMOBILE_API,
  }),
  "soeHealthCheck": () => ({
    "straighttalk": SOE_HEALTH_CHECK_API,
    "tracfone": SOE_HEALTH_CHECK_API,
    "totalwireless": SOE_HEALTH_CHECK_API,
    "simplemobile": SOE_HEALTH_CHECK_API,
  }),
  "soeEligibilityCheck": () => ({
    "straighttalk": SOE_ELIGIBILITY_CHECK_API,
    "tracfone": SOE_ELIGIBILITY_CHECK_API,
    "totalwireless": SOE_ELIGIBILITY_CHECK_API,
    "simplemobile": SOE_ELIGIBILITY_CHECK_API,
  }),
};